import type {MetadataItem} from 'src/api/saleor/generated'
import type {Maybe} from 'src/utils/Maybe'

export const typeIsMetaDataItem = (value: unknown): value is MetadataItem =>
  typeof value === 'object' &&
  value !== null &&
  'key' in value &&
  (value as {key: string}).key != null

export const getMediaDataVariants = (
  metadata: Maybe<Maybe<MetadataItem>[]>,
): Partial<MetadataItem> =>
  (metadata || [])
    .filter(typeIsMetaDataItem)
    .find(({key}) => key === 'unit_types') ?? {}
